export const lang = {
  schedule:"Planifier",
  debtor:"Modalité d'admission",
  taxed_amount:"Montant dû",
  received_amount:"M.Encaissé"
};
